<template>
  <VcModal
    :title="
      $t(
        !address
          ? addressType == AddressType.Shipping
            ? 'shared.company.add_or_update_address_modal.create_title'
            : 'shared.company.add_or_update_address_modal.create_billing_title'
          : 'shared.company.add_or_update_address_modal.edit_title',
      )
    "
    hide-actions
    is-mobile-fullscreen
    dividers
  >
    <template #default="{ close }">
      <h3 class="text-2xl font-extrabold">
        {{ $t("shared.company.add_or_update_address_modal.address_title") }}
      </h3>
      <div v-if="addressType == AddressType.Shipping" class="mb-2">
        {{ $t("shared.company.add_or_update_address_modal.contact_person_title") }}
      </div>

      <InnoAddressForm
        :model-value="address"
        :countries="countriesListTranslated"
        :disabled="loading"
        with-description-field
        required-phone
        required-city
        @save="saveAddress"
      >
        <template #append="{ dirty, valid }">
          <div class="flex flex-wrap items-center justify-between gap-4 pt-2 *:max-xs:flex-1">
            <VcButton min-width="8rem" :disabled="loading" color="secondary" variant="outline" @click="close">
              {{ $t("common.buttons.cancel") }}
            </VcButton>

            <VcButton min-width="8rem" :disabled="!valid || !dirty" :loading="loading" type="submit">
              {{ $t("common.buttons.save") }}
            </VcButton>
          </div>
        </template>
      </InnoAddressForm>
    </template>
  </VcModal>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useCountries } from "@/core/composables";
import { InnoAddressForm } from "@/shared/common";
import type { MemberAddressType } from "@/core/api/graphql/types";
import { AddressType } from "@/core/enums";

export interface IEmits {
  (event: "result", addess: MemberAddressType): void;
}

export interface IProps {
  address?: MemberAddressType;
  loading?: boolean;
  addressType?: AddressType;
}

const emit = defineEmits<IEmits>();

const props = defineProps<IProps>();

const { countries, countriesListTranslated, loadCountries } = useCountries();

function saveAddress(address: MemberAddressType) {
  emit("result", address);
}

onMounted(async () => {
  if (!countries.value.length) {
    await loadCountries();
  }
});
</script>
